module.exports = __webpack_public_path__ + "img/planner.55b212a2.png";